import React, { createContext, useState } from 'react';
import config from './config';

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [isActiveSport, setIsActiveSport] = useState(config.TabCricket);
  const setActiveSport = (sport) => setIsActiveSport(sport);
  const [isSuccessRes, setIsSuccessRes] = useState(false);
  const [isErrorRes, setIsErrorRes] = useState(false);
  const [isMobileMenuOpen, setmMenu] = useState(false);
  const [alerMsg, setAlerMsg] = useState('');
  const [stackArray, setStackArray] = useState();
  const [loggedIn, setLoggedIn] = useState(false);
  const [oneClickBetUpdate, setclickUpdate] = useState(false);
  const [betOnProcess, setbetPro] = useState(false);
  const [openDialog, setOpenDialog] = useState('');
  const [balanceData, Bonas] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isBannerOpend, setIsBanner] = useState(false);
  const [currentTheme, setCTheme] = useState(localStorage.getItem("theme"));


  const [exchangeData, setExchangeDatas] = useState();
  const setExchangeData = (time) => setExchangeDatas(time);
  const setIsBannerOpen = (time) => setIsBanner(time);
  const [loginPopupOpen, setLoginPops] = useState(false);
  const setLoginPop = (it) => setLoginPops(it); 

  const setLoading = (it) => setIsLoading(it);
  const setCurrentTheme = (it) => setCTheme(it);

  const setBalanceData = (it) => Bonas(it); 
  const UpdateOneClick = (it) => setclickUpdate(it); 

  const setBetOnProcess = (it) => setbetPro(it); 

  const openSuccessPopup = () => setIsSuccessRes(true); 
  const closeSuccessPopup = () => setIsSuccessRes(false);
  const setMobileMenu = (it) => setmMenu(it);
    
  const openErrorPopup = () => setIsErrorRes(true); 
  const closeErrorPopup = () => setIsErrorRes(false);
  
  const setAlertMsg = (msg) => setAlerMsg(msg);
  const isLoggedIn = () => setLoggedIn(true);
  const isLoggedOut = () => setLoggedIn(false);

  const openDialogSet = (id) => setOpenDialog(id);
  const clearDialog = () => setOpenDialog('');
  
  const setStackList = (list) => {
    if (list !== undefined) {
      setStackArray(list);      
    }    
  };
  
  return (
    <GlobalContext.Provider value={{
      isActiveSport,
      setActiveSport,
      openSuccessPopup,
      closeSuccessPopup,
      openErrorPopup,
      closeErrorPopup,
      setAlertMsg,
      isSuccessRes,
      isErrorRes,
      alerMsg,
      setStackList,
      stackArray,
      loggedIn,
      isLoggedIn,
      isLoggedOut,
      clearDialog,
      openDialogSet,
      openDialog,
      setBalanceData,
      balanceData,
      UpdateOneClick,
      oneClickBetUpdate,
      betOnProcess,
      setBetOnProcess,
      setLoginPop,
      loginPopupOpen,
      isLoading,
      setLoading,
      isMobileMenuOpen,
      setMobileMenu,
      exchangeData,
      setExchangeData,
      isBannerOpend,
      setIsBannerOpen,
      setCurrentTheme, 
      currentTheme
      }}>
      {children}
    </GlobalContext.Provider>
  );
};
